import { Box } from "theme-ui";

export default function CloseIcon(props) {
  return (
    <Box
      as="svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <path
        d="M10.5 2.5V1.5C10.5 0.947715 10.0523 0.5 9.5 0.5H1.5C0.947715 0.5 0.5 0.947715 0.5 1.5V11.5C0.5 12.0523 0.947715 12.5 1.5 12.5H4.5"
        stroke="black"
        strokeLinecap="round"
      />
      <rect x="6.5" y="4.5" width="10" height="12" rx="1" stroke="black" />
    </Box>
  );
}
